// extracted by mini-css-extract-plugin
export default {"file-explorer__content":"fileExplorer_file-explorer__content__2+OF1"};